import { Radio } from "antd";
import { useTranslation } from "react-i18next";

const TabsHolder = ({ active, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="buy-and-supply__tabs-holder">
      <Radio.Group
        name="tabs-2026"
        defaultValue={1}
        optionType="button"
        buttonStyle="solid"
        value={active}
        onChange={onTabChange}
        className="buy-and-supply__tabs-holder__main-holder d-flex justify-content-between align-items-center"
      >
        <Radio
          value={1}
          className="fsize-8 fw-bold buy-and-supply__tabs-holder__main-holder__tab"
        >
          {t("buyAndSupply2026.buyAndSupply")}
        </Radio>
        <Radio
          value={2}
          className="fsize-8 fw-bold buy-and-supply__tabs-holder__main-holder__tab buy-and-supply__tabs-holder__main-holder__tab--balance"
        >
          {t("buyAndSupply2026.wallet")}
        </Radio>
        <Radio
          value={3}
          className="fsize-8 fw-bold buy-and-supply__tabs-holder__main-holder__tab buy-and-supply__tabs-holder__main-holder__tab--pending-orders"
        >
          {t("buyAndSupply2026.orders")}
        </Radio>
      </Radio.Group>
    </div>
  );
};

export default TabsHolder;
